import Poppy from 'poppy';

const selectors = {
  tooltip: 'data-tooltip',
  tooltipStopMouseEnter: 'data-tooltip-stop-mouseenter',
};

const classes = {
  tooltipDefault: 'poppy__tooltip',
};

let sections = {};

export default class Tooltip {
  constructor(el, options = {}) {
    this.tooltip = el;
    if (!this.tooltip.hasAttribute(selectors.tooltip)) return;
    this.label = this.tooltip.getAttribute(selectors.tooltip);
    this.pop = null;
    this.class = options.class || classes.tooltipDefault;
    this.transitionSpeed = options.transitionSpeed || 200;
    this.tooltipPosition = options.position || 'bottom';
    this.addPinEvent = () => this.addPin();
    this.addPinMouseEvent = () => this.addPin(true);
    this.removePinEvent = () => this.removePin();
    this.removePinMouseEvent = () => this.removePin(true);
    this.init();
  }

  init() {
    this.pop = new Poppy({
      target: this.tooltip,
      popover: `
      <div class="${this.class}__wrapper">
      <div class="${this.class}">
      ${this.label}
      </div>
      </div>
      `,
      position: this.tooltipPosition,
      transitionSpeed: this.transitionSpeed,
    });

    this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.addEventListener('poppy:init', this.addPinEvent);
    document.addEventListener('poppy:close', this.removePinEvent);
    document.addEventListener('theme:scroll', this.removePinEvent);
  }

  addPin(stopMouseEnter = false) {
    if (!this.pop) return;

    if ((stopMouseEnter && !this.tooltip.hasAttribute(selectors.tooltipStopMouseEnter)) || !stopMouseEnter) {
      this.pop.pin();
    }
  }

  removePin(stopMouseEnter = false) {
    if (!this.pop && !this.pop.state.pinned) return;

    if ((stopMouseEnter && !this.tooltip.hasAttribute(selectors.tooltipStopMouseEnter)) || !stopMouseEnter) {
      this.pop.unpin();
    }
  }

  unload() {
    if (!this.pop) return;
    this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.removeEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.removeEventListener('poppy:init', this.addPinEvent);
    document.removeEventListener('poppy:close', this.removePinEvent);
    document.removeEventListener('theme:scroll', this.removePinEvent);
  }
}

export const tooltipSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(`[${selectors.tooltip}]`);
    els.forEach((el) => {
      sections[this.id].push(new Tooltip(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};
